import { Component, OnInit } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";

@Component({
    //selector: "customer-knowledgebase",
    templateUrl: "../templates/template1/views/knowledgebase.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/dashboard.less"
    ],
    providers: [AuthorizationPipe]
})


export class KnowledgeBaseComponent implements OnInit {

    ngOnInit(): void { };
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/knowledgebase.component.ts